"use client";

import {
  ActionIcon,
  Button,
  Drawer,
  Indicator,
  Menu,
  useMantineTheme,
} from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import FilterListRounded from "@mui/icons-material/FilterListRounded";
import { ReactNode } from "react";
import classes from "./FilterWrapper.module.css";

interface FilterButtonProps {
  children: ReactNode;
  activeFilterCount: number;
}

export default function FilterWrapper({
  children,
  activeFilterCount,
}: FilterButtonProps) {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);
  const [drawerOpened, { open: openDrawer, close: closeDrawer }] =
    useDisclosure(false);

  if (isMobile) {
    return (
      <>
        <Button
          variant="outline"
          aria-label="Filters"
          onClick={openDrawer}
          className={classes.filterButton}
          rightSection={<FilterListRounded />}
        >
          Filters
        </Button>
        <Drawer
          opened={drawerOpened}
          onClose={closeDrawer}
          position="bottom"
          size="auto"
          withCloseButton={true}
          classNames={{
            content: classes.drawerContent,
            header: classes.drawerHeader,
            body: classes.drawerBody,
          }}
        >
          {children}
        </Drawer>
      </>
    );
  }

  return (
    <Menu
      shadow="lg"
      width={450}
      position="bottom-end"
      offset={8}
      aria-label="Filters"
      {...({ withRoles: false } as { withRoles?: boolean })}
    >
      <Menu.Target>
        <Indicator
          label={activeFilterCount}
          size={14}
          classNames={{
            indicator: classes.filterIndicator,
          }}
        >
          <ActionIcon
            variant="transparent"
            className={classes.filterButton}
            aria-label="Filters"
          >
            <FilterListRounded />
          </ActionIcon>
        </Indicator>
      </Menu.Target>
      <Menu.Dropdown className={classes.menuDropdown}>{children}</Menu.Dropdown>
    </Menu>
  );
}

export const useFilterWrapperStyles = () => ({ classes });
